<template>
  <div>
    <Table
      resource="CategoryV2"
      :actions="actions"
      :items="$store.getters['categoryV2/tableData']"
      :detail="$store.getters['categoryV2/detailData']"
      :detail-route="row => `/v2/categories/${row.id}/detail`"
      :fields="$store.getters['categoryV2/tableFields']"
      :pagination="$store.state.categoryV2.tablePagination"
      :keyword="$store.state.categoryV2.tableKeyword"
      :loading="$store.state.categoryV2.loadingTable"
      :filter="$store.state.categoryV2.tableFilter"
      :sort="$store.state.categoryV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: { Table },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at',
          direction: 'desc',
          label: 'Terbaru',
          default: true,
        },
        {
          key: 'created_at',
          direction: 'asc',
          label: 'Terlama',
        },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('categoryV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('categoryV2/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('categoryV2/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('categoryV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('categoryV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('categoryV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('categoryV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('categoryV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('categoryV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('categoryV2/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
